import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M9.333 9.501v1.394A4 4 0 004 14.666H2.667A5.334 5.334 0 019.333 9.5zM8 8.666c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-1.333A2.666 2.666 0 108 2a2.666 2.666 0 100 5.333zm3.862 5.943l2.357-2.357.943.943-3.3 3.3-2.357-2.357.943-.943 1.413 1.414h.001z"
      ></path>
    </svg>
  )
}

export default Icon
